export default "https://cdn-static.gokick.com/assets/78cedee4a9b459fbef408ae219aa3203e6c5e731/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";